import { type SxProps, type Theme, Box } from '@mui/material'

type TabPanelProps<T extends string> = {
  children?: React.ReactNode
  // Style override
  sx?: SxProps<Theme>
} & (
  | {
      index: number
      value: number
    }
  | {
      index: T
      value: T
    }
)

const TabPanel = <T extends string>({ children, index, value, sx }: TabPanelProps<T>) => {
  if (index !== value) {
    return null // Better than display: none because the inner DataGrids do not like to be hidden this way
  }

  return (
    <Box
      sx={{
        marginTop: '16px',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default TabPanel
